var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpreeillustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29",
    "data-name": "Group 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.106,
    height: 135.443,
    viewBox: "0 0 181.106 135.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M58.22,0h84.257V87.234a50.675,50.675,0,0,1-9.216,29.66,44.431,44.431,0,0,1-19.18,15.321,45.215,45.215,0,0,1-17.367,3.227h-18.8v-29.81l19.679-.615s13.524,0,12.909-20.91H58.22Z",
    transform: "translate(38.629)",
    fill: "#ea9c1c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M0,0H84.257V87.234a50.675,50.675,0,0,1-9.216,29.66,44.431,44.431,0,0,1-19.18,15.321,45.215,45.215,0,0,1-17.367,3.227H19.7v-29.81l19.679-.615s13.524,0,12.909-20.91H0Z",
    fill: "#ea9c1c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreeillustration);
export default __webpack_public_path__ + "static/media/spreeillustration.59f8e83643d93651bccffa0961d7afe5.svg";
export { ForwardRef as ReactComponent };